import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { baseUrl } from '../../baseUrl';
import './ResetPassword.css'; // Import custom CSS file for styling

const ResetPassword = () => {
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (password !== confirmPassword) {
      setMessage('Passwords do not match');
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(`${baseUrl}/student/reset-password`, {
        token,
        password,
      });
      setMessage(response.data.message);
    } catch (error) {
      setMessage(error.response?.data?.message || 'Something went wrong');
    }

    setLoading(false);
  };

  return (
    <div className="reset-password-container">
      <div className="reset-password-form">
        <h2 className="text-center mb-4">Reset Password</h2>
        <form onSubmit={handleSubmit}>
          <div style={{position:'relative'}}>
          <div className="form-group">
            <input
            style={{paddingRight:'30px'}}
              type={showPassword?'text':'password'}
              className="form-control"
              placeholder="Enter new password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <i className={`${showPassword ? 'ti-lock' : 'ti-key'}`}
              onClick={() => setShowPassword(!showPassword)}
              style={{position:'absolute',right:'10px',top:'50%',transform:'translateY(-50%)'}}
            ></i>
          </div>
          </div>
          <div style={{position:'relative'}}>
          <div className="form-group">
            <input
              style={{ paddingRight: '30px' }}
              type={showConfirmPassword?'text':'password'}
              className="form-control"
              placeholder="Confirm new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <i className={`${showConfirmPassword ? 'ti-lock' : 'ti-key'}`}
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}
            ></i>
          </div>
          </div>
          <button className="btn btn-primary btn-block" type="submit" disabled={loading}>
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>
        {message && <div className="mt-3 alert alert-info">{message}</div>}
      </div>
    </div>
  );
};

export default ResetPassword;
